// ** Angle Icons Data

export const angleIcons = {
	"angle-double-left": {
		viewBox: "0 0 320 512",
		variants: {
			light: {
				"data-prefix": "fal",
				"data-icon": "angle-double-left",
				source: "https://fontawesome.com/icons/angle-double-left",
				license: "https://fontawesome.com/license",
				path: "M153.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L192.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L153 264.5c-4.6-4.7-4.6-12.3.1-17zm-128 17l117.8 116c4.7 4.7 12.3 4.7 17 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L64.7 256l102.2-100.4c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L25 247.5c-4.6 4.7-4.6 12.3.1 17z",
			},
		},
	},
	"angle-double-right": {
		viewBox: "0 0 320 512",
		variants: {
			light: {
				"data-prefix": "fal",
				"data-icon": "angle-double-right",
				source: "https://fontawesome.com/icons/angle-double-right",
				license: "https://fontawesome.com/license",
				path: "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17zm128-17l-117.8-116c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17L255.3 256 153.1 356.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l117.8-116c4.6-4.7 4.6-12.3-.1-17z",
			},
		},
	},
	"angle-left": {
		viewBox: "0 0 192 512",
		variants: {
			light: {
				"data-prefix": "fal",
				"data-icon": "angle-left",
				source: "https://fontawesome.com/icons/angle-left",
				license: "https://fontawesome.com/license",
				path: "M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z",
			},
		},
	},
	"angle-right": {
		viewBox: "0 0 192 512",
		variants: {
			light: {
				"data-prefix": "fal",
				"data-icon": "angle-right",
				source: "https://fontawesome.com/icons/angle-right",
				license: "https://fontawesome.com/license",
				path: "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z",
			},
		},
	},
};
